export const clevertapProjectIds = {
  production: '869-555-Z96Z',
  staging: 'TEST-969-555-Z96Z',
  development: 'TEST-W79-555-Z96Z'
}